import React from 'react';
import { Card, Row, Col, Typography } from "antd";

const { Title, Text } = Typography;

const CustomerStatsCards = ({ mapData }) => {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col xs={24} md={6}>
        <Card>
          <Text type="secondary">Total Customers</Text>
          <Title level={2}>{mapData.total_customers.toLocaleString()}</Title>
          <Text type="secondary">Across {mapData.total_states} states</Text>
        </Card>
      </Col>
      <Col xs={24} md={6}>
        <Card>
          <Text type="secondary">Total Sales</Text>
          <Title level={2}>${mapData.total_sales.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}</Title>
          <Text type="secondary">{mapData.total_cities} cities</Text>
        </Card>
      </Col>
      <Col xs={24} md={6}>
        <Card>
          <Text type="secondary">Total Orders</Text>
          <Title level={2}>{mapData.total_orders.toLocaleString()}</Title>
          <Text type="secondary">
            {mapData.total_customers
              ? `${(mapData.total_orders / mapData.total_customers).toFixed(2)} per customer`
              : '0 per customer'}
          </Text>
        </Card>
      </Col>
      <Col xs={24} md={6}>
        <Card>
          <Text type="secondary">Avg Sale per Customer</Text>
          <Title level={2}>
            {mapData.total_customers
              ? `$${(mapData.total_sales / mapData.total_customers).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}`
              : '$0.00'}
          </Title>
          <Text type="secondary">Lifetime value</Text>
        </Card>
      </Col>
    </Row>
  );
};

export default CustomerStatsCards;
